import { render } from "./Create.vue?vue&type=template&id=baf4c4e4&scoped=true"
import script from "./Create.vue?vue&type=script&lang=ts"
export * from "./Create.vue?vue&type=script&lang=ts"

import "./Create.vue?vue&type=style&index=0&id=baf4c4e4&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-baf4c4e4"

export default script